import { styled } from "@mui/system";
import Button from '@mui/material/Button';

const MuiButton = styled(Button)({
    background: 'linear-gradient(90deg, #19D3AE, #0FCFEC)',
    color: '#fff',
    padding: '10px 15px',
    fontWeight: 700
})

export default MuiButton;